import { View } from "react-native";
import { useTailwind } from "tailwind-rn";

import { Input } from "../../../../components";
import { FormikFormSwitch } from "../../components/FormSwitch";
import useProductFormFormik from "../../hooks/useProductFormFormik";

export default function SaleEmail() {
  const {
    values: {
      sale_email: { enabled },
    },
  } = useProductFormFormik();
  const tailwind = useTailwind();

  const title = "Correo post-compra";
  const body = `Pulsa para ${
    enabled ? "desactivar" : "activar"
  } un correo personalizado que se envía automáticamente con la compra`;

  return (
    <View style={tailwind("mt-4 gap-2")}>
      <FormikFormSwitch
        fieldName="sale_email.enabled"
        title={title}
        body={body}
      />
      {enabled && <Input.Formik.Multiline fieldName="sale_email.text" />}
    </View>
  );
}
